import { render, staticRenderFns } from "./ContactsImport.vue?vue&type=template&id=166114a0&scoped=true&"
import script from "./ContactsImport.vue?vue&type=script&lang=js&"
export * from "./ContactsImport.vue?vue&type=script&lang=js&"
import style0 from "./ContactsImport.vue?vue&type=style&index=0&id=166114a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166114a0",
  null
  
)

export default component.exports